import * as actions from './schemeImportReducer';
import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import handleErrorResponse from '../../../../../helpers/handleErrorResponse';
import { clearFiles } from '../../../../../common/components/Upload/UploadRedux';

export function confirmImport(fileId, isConfirmed) {
  const END_POINT = '/products/import';
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.post(END_POINT, {
      meta: {
        file: fileId,
        confirmed: isConfirmed,
      },
    })
      .then((response) => {
        dispatch({
          type: actions.CONFIRM_IMPORT,
          data: {
            schemes: response.data.meta.schemes,
            schemeGroups: response.data.meta.scheme_groups,
          },
        });
        if (isConfirmed && response.status === 200) {
          toastr.success('Success', 'Your scheme(s) have been imported');
          dispatch(importConfirmed(true));
          dispatch(clearFiles());
          //dispatch(clearSchemes())
        }
        return true;
      })
      .catch((error) => {
        dispatch(clearSchemes());
        dispatch(clearFiles());
        dispatch(importConfirmed(false));
        dispatch(importedError());
        handleErrorResponse(error);
      });
  };
}

export function clearSchemes() {
  return {
    type: actions.CLEAR_SCHEMES,
  };
}

export function importedError() {
  return {
    type: actions.IMPORTED_ERROR,
  };
}

export function importConfirmed(status) {
  return {
    type: actions.IS_IMPORTED,
    status,
  };
}

export function isLoading(status) {
  return {
    type: actions.IS_LOADING,
    status,
  };
}
